import { environment } from '../../../environments/environment';

window.addEventListener('load', function () {
  (<any>window).ga('create', environment.analytics.googleAnalyticsAccountId, 'none');
});